import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetMarketChgDistributionOverviewParams,
  TGetMarketChgDistributionOverviewResponse,
  getMarketChgDistributionOverview,
  TGetCurrencyTradeSupportParams,
  TGetCurrencyTradeSupportResponse,
  getCurrencyTradeSupport,
  TGetCurrencyTradeRecommendParams,
  TGetCurrencyTradeRecommendResponse,
  getCurrencyTradeRecommend,
  TGetMarketContractForceLiquidationParams,
  TGetMarketContractForceLiquidationResponse,
  getMarketContractForceLiquidation,
  TGetMarketContractFundingRateParams,
  TGetMarketContractFundingRateResponse,
  getMarketContractFundingRate,
  TGetMarketContractHistoryAmountParams,
  TGetMarketContractHistoryAmountResponse,
  getMarketContractHistoryAmount,
  TGetMarketContractOpenInterestParams,
  TGetMarketContractOpenInterestResponse,
  getMarketContractOpenInterest,
  TGetMarketContractOverviewVolumeParams,
  TGetMarketContractOverviewVolumeResponse,
  getMarketContractOverviewVolume,
  TGetMarketSpotOverviewVolumeParams,
  TGetMarketSpotOverviewVolumeResponse,
  getMarketSpotOverviewVolume,
  TGetMarketSpotOverviewChartTotalMarketCapParams,
  TGetMarketSpotOverviewChartTotalMarketCapResponse,
  getMarketSpotOverviewChartTotalMarketCap,
  TGetMarketSpotOverviewChartStableParams,
  TGetMarketSpotOverviewChartStableResponse,
  getMarketSpotOverviewChartStable,
  TGetMarketSpotOverviewChartVolumeParams,
  TGetMarketSpotOverviewChartVolumeResponse,
  getMarketSpotOverviewChartVolume,
  TGetMarketSpotBtcDominanceParams,
  TGetMarketSpotBtcDominanceResponse,
  getMarketSpotBtcDominance,
  TGetMarketSpotOverviewChartEtfListParams,
  TGetMarketSpotOverviewChartEtfListResponse,
  getMarketSpotOverviewChartEtfList,
  TGetMarketSpotOverviewChartEtfFlowParams,
  TGetMarketSpotOverviewChartEtfFlowResponse,
  getMarketSpotOverviewChartEtfFlow,
  TGetMarketContractCurrenciesParams,
  TGetMarketContractCurrenciesResponse,
  getMarketContractCurrencies,
  TGetMarketRankingMainTradesParams,
  TGetMarketRankingMainTradesResponse,
  getMarketRankingMainTrades,
  TGetMarketRecommendNewListingsParams,
  TGetMarketRecommendNewListingsResponse,
  getMarketRecommendNewListings,
  TGetMarketRankingNewListingsParams,
  TGetMarketRankingNewListingsResponse,
  getMarketRankingNewListings,
  TGetMarketRankingRecommendsParams,
  TGetMarketRankingRecommendsResponse,
  getMarketRankingRecommends,
  TGetMarketRankingTopGainersParams,
  TGetMarketRankingTopGainersResponse,
  getMarketRankingTopGainers,
  TGetStatSpotTakerVolumeParams,
  TGetStatSpotTakerVolumeResponse,
  getStatSpotTakerVolume,
  TGetMarketRankingTopLosersParams,
  TGetMarketRankingTopLosersResponse,
  getMarketRankingTopLosers,
  TGetMarketRankingTurnOverParams,
  TGetMarketRankingTurnOverResponse,
  getMarketRankingTurnOver,
  TGetMarketRankingWeekStarParams,
  TGetMarketRankingWeekStarResponse,
  getMarketRankingWeekStar,
  TGetMarketZoneDetailParams,
  TGetMarketZoneDetailResponse,
  getMarketZoneDetail,
  TGetStatContractLsAccountRatioParams,
  TGetStatContractLsAccountRatioResponse,
  getStatContractLsAccountRatio,
  TGetStatContractOpenInterestVolumeParams,
  TGetStatContractOpenInterestVolumeResponse,
  getStatContractOpenInterestVolume,
  TGetStatContractTakerVolumeParams,
  TGetStatContractTakerVolumeResponse,
  getStatContractTakerVolume,
  TGetStatSpotFlowAnalysisParams,
  TGetStatSpotFlowAnalysisResponse,
  getStatSpotFlowAnalysis,
  TGetTradeSpotFetchKlineOrdersParams,
  TGetTradeSpotFetchKlineOrdersResponse,
  getTradeSpotFetchKlineOrders,
  TGetMarketZoneListParams,
  TGetMarketZoneListResponse,
  getMarketZoneList,
  TGetMarketTradeStatCurrenciesParams,
  TGetMarketTradeStatCurrenciesResponse,
  getMarketTradeStatCurrencies,
  TGetFunctionsEcoZonesParams,
  TGetFunctionsEcoZonesResponse,
  getFunctionsEcoZones,
  TGetMarketHeatmapListingParams,
  TGetMarketHeatmapListingResponse,
  getMarketHeatmapListing,
  TGetMarketRankingHotListingsParams,
  TGetMarketRankingHotListingsResponse,
  getMarketRankingHotListings,
  TGetMarketTrendlinesParams,
  TGetMarketTrendlinesResponse,
  getMarketTrendlines,
  TGetMarketRegionCurrenciesParams,
  TGetMarketRegionCurrenciesResponse,
  getMarketRegionCurrencies,
  TGetMarketSearchPopularParams,
  TGetMarketSearchPopularResponse,
  getMarketSearchPopular,
  TPostMarketSearchResultParams,
  TPostMarketSearchResultResponse,
  postMarketSearchResult,
  TGetMarketMultiChangeParams,
  TGetMarketMultiChangeResponse,
  getMarketMultiChange,
} from 'core/service/yapi/hk-web/MarketCalc/api'
// 行情数据接口
// 行情涨跌分布数据
export const useGetMarketChgDistributionOverviewQuery = (
  params?: TGetMarketChgDistributionOverviewParams,
  options?: TUseQueryOptions<TGetMarketChgDistributionOverviewResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketChgDistributionOverview', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketChgDistributionOverview(params),
  })
}

// 查询币种支持的杠杆/合约/现货类型
export const useGetCurrencyTradeSupportQuery = (
  params?: TGetCurrencyTradeSupportParams,
  options?: TUseQueryOptions<TGetCurrencyTradeSupportResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'CurrencyTradeSupport', 'GET', ...Object.values(params || {})],
    queryFn: () => getCurrencyTradeSupport(params),
  })
}

// 查询币种支持买币/理财推荐
export const useGetCurrencyTradeRecommendQuery = (
  params?: TGetCurrencyTradeRecommendParams,
  options?: TUseQueryOptions<TGetCurrencyTradeRecommendResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'CurrencyTradeRecommend', 'GET', ...Object.values(params || {})],
    queryFn: () => getCurrencyTradeRecommend(params),
  })
}

// 全网风向标-合约爆仓数据
export const useGetMarketContractForceLiquidationQuery = (
  params?: TGetMarketContractForceLiquidationParams,
  options?: TUseQueryOptions<TGetMarketContractForceLiquidationResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketContractForceLiquidation', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketContractForceLiquidation(params),
  })
}

// 全网风向标-资金费率数据
export const useGetMarketContractFundingRateQuery = (
  params?: TGetMarketContractFundingRateParams,
  options?: TUseQueryOptions<TGetMarketContractFundingRateResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketContractFundingRate', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketContractFundingRate(params),
  })
}

// 全网风向标-全网合约历史成交额
export const useGetMarketContractHistoryAmountQuery = (
  params?: TGetMarketContractHistoryAmountParams,
  options?: TUseQueryOptions<TGetMarketContractHistoryAmountResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketContractHistoryAmount', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketContractHistoryAmount(params),
  })
}

// 全网风向标-全网合约持仓量数据
export const useGetMarketContractOpenInterestQuery = (
  params?: TGetMarketContractOpenInterestParams,
  options?: TUseQueryOptions<TGetMarketContractOpenInterestResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketContractOpenInterest', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketContractOpenInterest(params),
  })
}

// 全网风向标-概览数据
export const useGetMarketContractOverviewVolumeQuery = (
  params?: TGetMarketContractOverviewVolumeParams,
  options?: TUseQueryOptions<TGetMarketContractOverviewVolumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketContractOverviewVolume', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketContractOverviewVolume(params),
  })
}

// 全网风向标-现货概览数据
export const useGetMarketSpotOverviewVolumeQuery = (
  params?: TGetMarketSpotOverviewVolumeParams,
  options?: TUseQueryOptions<TGetMarketSpotOverviewVolumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotOverviewVolume', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotOverviewVolume(params),
  })
}

// 全网风向标-现货大盘图表-总市值
export const useGetMarketSpotOverviewChartTotalMarketCapQuery = (
  params?: TGetMarketSpotOverviewChartTotalMarketCapParams,
  options?: TUseQueryOptions<TGetMarketSpotOverviewChartTotalMarketCapResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotOverviewChartTotalMarketCap', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotOverviewChartTotalMarketCap(params),
  })
}

// 全网风向标-现货大盘图表-稳定币
export const useGetMarketSpotOverviewChartStableQuery = (
  params?: TGetMarketSpotOverviewChartStableParams,
  options?: TUseQueryOptions<TGetMarketSpotOverviewChartStableResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotOverviewChartStable', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotOverviewChartStable(params),
  })
}

// 全网风向标-现货大盘图表-24小时交易量
export const useGetMarketSpotOverviewChartVolumeQuery = (
  params?: TGetMarketSpotOverviewChartVolumeParams,
  options?: TUseQueryOptions<TGetMarketSpotOverviewChartVolumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotOverviewChartVolume', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotOverviewChartVolume(params),
  })
}

// 全网风向标-现货大盘图表-BTC市值占比
export const useGetMarketSpotBtcDominanceQuery = (
  params?: TGetMarketSpotBtcDominanceParams,
  options?: TUseQueryOptions<TGetMarketSpotBtcDominanceResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotBtcDominance', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotBtcDominance(params),
  })
}

// 全网风向标-现货大盘图表-ETF机构列表
export const useGetMarketSpotOverviewChartEtfListQuery = (
  params?: TGetMarketSpotOverviewChartEtfListParams,
  options?: TUseQueryOptions<TGetMarketSpotOverviewChartEtfListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotOverviewChartEtfList', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotOverviewChartEtfList(params),
  })
}

// 全网风向标-现货大盘图表-ETF净流入流出
export const useGetMarketSpotOverviewChartEtfFlowQuery = (
  params?: TGetMarketSpotOverviewChartEtfFlowParams,
  options?: TUseQueryOptions<TGetMarketSpotOverviewChartEtfFlowResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSpotOverviewChartEtfFlow', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSpotOverviewChartEtfFlow(params),
  })
}

// 全网风向标-合约统计币种列表
export const useGetMarketContractCurrenciesQuery = (
  params?: TGetMarketContractCurrenciesParams,
  options?: TUseQueryOptions<TGetMarketContractCurrenciesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketContractCurrencies', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketContractCurrencies(params),
  })
}

// 查询主流交易对行情数据
export const useGetMarketRankingMainTradesQuery = (
  params?: TGetMarketRankingMainTradesParams,
  options?: TUseQueryOptions<TGetMarketRankingMainTradesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingMainTrades', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingMainTrades(params),
  })
}

// 查询新币上线推荐
export const useGetMarketRecommendNewListingsQuery = (
  params?: TGetMarketRecommendNewListingsParams,
  options?: TUseQueryOptions<TGetMarketRecommendNewListingsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRecommendNewListings', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRecommendNewListings(params),
  })
}

// 查询新币榜行情数据
export const useGetMarketRankingNewListingsQuery = (
  params?: TGetMarketRankingNewListingsParams,
  options?: TUseQueryOptions<TGetMarketRankingNewListingsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingNewListings', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingNewListings(params),
  })
}

// 查询推荐交易对行情数据
export const useGetMarketRankingRecommendsQuery = (
  params?: TGetMarketRankingRecommendsParams,
  options?: TUseQueryOptions<TGetMarketRankingRecommendsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingRecommends', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingRecommends(params),
  })
}

// 查询涨幅榜行情数据
export const useGetMarketRankingTopGainersQuery = (
  params?: TGetMarketRankingTopGainersParams,
  options?: TUseQueryOptions<TGetMarketRankingTopGainersResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingTopGainers', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingTopGainers(params),
  })
}

// 现货主动买入卖出
export const useGetStatSpotTakerVolumeQuery = (
  params?: TGetStatSpotTakerVolumeParams,
  options?: TUseQueryOptions<TGetStatSpotTakerVolumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'StatSpotTakerVolume', 'GET', ...Object.values(params || {})],
    queryFn: () => getStatSpotTakerVolume(params),
  })
}

// 查询跌幅榜行情数据
export const useGetMarketRankingTopLosersQuery = (
  params?: TGetMarketRankingTopLosersParams,
  options?: TUseQueryOptions<TGetMarketRankingTopLosersResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingTopLosers', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingTopLosers(params),
  })
}

// 查询成交额榜行情数据
export const useGetMarketRankingTurnOverQuery = (
  params?: TGetMarketRankingTurnOverParams,
  options?: TUseQueryOptions<TGetMarketRankingTurnOverResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingTurnOver', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingTurnOver(params),
  })
}

// 查询周热力榜行情数据
export const useGetMarketRankingWeekStarQuery = (
  params?: TGetMarketRankingWeekStarParams,
  options?: TUseQueryOptions<TGetMarketRankingWeekStarResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingWeekStar', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingWeekStar(params),
  })
}

// 生态专区详情
export const useGetMarketZoneDetailQuery = (
  params?: TGetMarketZoneDetailParams,
  options?: TUseQueryOptions<TGetMarketZoneDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketZoneDetail', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketZoneDetail(params),
  })
}

// 合约多空人数比数据
export const useGetStatContractLsAccountRatioQuery = (
  params?: TGetStatContractLsAccountRatioParams,
  options?: TUseQueryOptions<TGetStatContractLsAccountRatioResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'StatContractLsAccountRatio', 'GET', ...Object.values(params || {})],
    queryFn: () => getStatContractLsAccountRatio(params),
  })
}

// 合约持仓总量数据
export const useGetStatContractOpenInterestVolumeQuery = (
  params?: TGetStatContractOpenInterestVolumeParams,
  options?: TUseQueryOptions<TGetStatContractOpenInterestVolumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'StatContractOpenInterestVolume', 'GET', ...Object.values(params || {})],
    queryFn: () => getStatContractOpenInterestVolume(params),
  })
}

// 合约主动买入卖出
export const useGetStatContractTakerVolumeQuery = (
  params?: TGetStatContractTakerVolumeParams,
  options?: TUseQueryOptions<TGetStatContractTakerVolumeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'StatContractTakerVolume', 'GET', ...Object.values(params || {})],
    queryFn: () => getStatContractTakerVolume(params),
  })
}

// 现货资金流向分析
export const useGetStatSpotFlowAnalysisQuery = (
  params?: TGetStatSpotFlowAnalysisParams,
  options?: TUseQueryOptions<TGetStatSpotFlowAnalysisResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'StatSpotFlowAnalysis', 'GET', ...Object.values(params || {})],
    queryFn: () => getStatSpotFlowAnalysis(params),
  })
}

// 查询现货K线历史委托
export const useGetTradeSpotFetchKlineOrdersQuery = (
  params?: TGetTradeSpotFetchKlineOrdersParams,
  options?: TUseQueryOptions<TGetTradeSpotFetchKlineOrdersResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'TradeSpotFetchKlineOrders', 'GET', ...Object.values(params || {})],
    queryFn: () => getTradeSpotFetchKlineOrders(params),
  })
}

// 生态专区列表
export const useGetMarketZoneListQuery = (
  params?: TGetMarketZoneListParams,
  options?: TUseQueryOptions<TGetMarketZoneListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketZoneList', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketZoneList(params),
  })
}

// 交易数据统计币种列表
export const useGetMarketTradeStatCurrenciesQuery = (
  params?: TGetMarketTradeStatCurrenciesParams,
  options?: TUseQueryOptions<TGetMarketTradeStatCurrenciesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketTradeStatCurrencies', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketTradeStatCurrencies(params),
  })
}

// 菜单生态专区列表
export const useGetFunctionsEcoZonesQuery = (
  params?: TGetFunctionsEcoZonesParams,
  options?: TUseQueryOptions<TGetFunctionsEcoZonesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'FunctionsEcoZones', 'GET', ...Object.values(params || {})],
    queryFn: () => getFunctionsEcoZones(params),
  })
}

// 币种市值热力图
export const useGetMarketHeatmapListingQuery = (
  params?: TGetMarketHeatmapListingParams,
  options?: TUseQueryOptions<TGetMarketHeatmapListingResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketHeatmapListing', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketHeatmapListing(params),
  })
}

// 查询热门榜行情数据
export const useGetMarketRankingHotListingsQuery = (
  params?: TGetMarketRankingHotListingsParams,
  options?: TUseQueryOptions<TGetMarketRankingHotListingsResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRankingHotListings', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRankingHotListings(params),
  })
}

// 查询24H涨跌走势图数据
export const useGetMarketTrendlinesQuery = (
  params?: TGetMarketTrendlinesParams,
  options?: TUseQueryOptions<TGetMarketTrendlinesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketTrendlines', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketTrendlines(params),
  })
}

// 查询板块币种列表
export const useGetMarketRegionCurrenciesQuery = (
  params?: TGetMarketRegionCurrenciesParams,
  options?: TUseQueryOptions<TGetMarketRegionCurrenciesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketRegionCurrencies', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketRegionCurrencies(params),
  })
}

// 搜索热门推荐
export const useGetMarketSearchPopularQuery = (
  params?: TGetMarketSearchPopularParams,
  options?: TUseQueryOptions<TGetMarketSearchPopularResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSearchPopular', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketSearchPopular(params),
  })
}

// 币对搜索结果
export const usePostMarketSearchResultMutation = (
  mutationOptions?: TUseMutationOptions<TPostMarketSearchResultResponse, TPostMarketSearchResultParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['MarketCalc', 'MarketSearchResult', 'Post'],
    mutationFn: (params?: TPostMarketSearchResultParams) => postMarketSearchResult(params),
  })
}

// 行情多涨跌幅
export const useGetMarketMultiChangeQuery = (
  params?: TGetMarketMultiChangeParams,
  options?: TUseQueryOptions<TGetMarketMultiChangeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketMultiChange', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketMultiChange(params),
  })
}
